import React from 'react';
import T from 'prop-types';
// icons
import { ReactComponent as RemoveIcon } from 'icons/trash.svg';
// styles
import classnames from 'classnames/bind';
import styles from './Button.module.scss';

const cx = classnames.bind(styles);

const RemoveButton = ({ onClick, className }) => {
  return (
    <div role="button" className={cx('remove-button', className)} onClick={onClick}>
      <RemoveIcon />
    </div>
  );
};

RemoveButton.propTypes = {
  onClick: T.func.isRequired,
  className: T.string,
};

export default RemoveButton;
